import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  Dropdown,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { Formik } from "formik";
import { Typeahead } from "react-bootstrap-typeahead";

import CustomNavbar from "../../../components/CustomNavbar";
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";

import messages from "../../../redux/messages";
import SibebarDescriptorsProfiles from "../../../components/descriptorsProfiles/SibebarDescriptorsProfiles";
import {
  getAssignCompetencies,
  getAssignCompetenciesById,
  saveAssignCompetencies,
  editAssignCompetencies,
  deleteAssignCompetencies,
  saveAssignCompetenciesMF,
} from "../../../redux/descriptorsProfiles/assignCompetencies/actions";
import { getCompetenciesDesc } from "../../../redux/descriptorsProfiles/competenciesDesc/actions";
import { getCompetenciesType } from "../../../redux/descriptorsProfiles/CompetenciesType/actions";
import { getAreas } from "../../../redux/descriptorsProfiles/areas/actions";
import { getDivision } from "../../../redux/division/actions";
import { getClassification } from "../../../redux/Classification/actions";

const AssignCompetencies = (props) => {
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [competencieSelected, setCompetencieSelected] = useState([]);
  const [tipoCompetenciaSelected, setTipoCompetenciaSelected] = useState([]);
  const [areaSelected, setAreaSelected] = useState([]);
  const [divisionSelected, setDivisionSelected] = useState([]);
  const [classificationSelected, setClassificationSelected] = useState([]);

  const dispatch = useDispatch();

  const schema = Yup.object().shape({
    //nombre: Yup.string().required("***Campo requerido"),
    //descripcion: Yup.string().required("***Campo requerido"),
    // descriptor: Yup.string().required("**Campo requerido"),
    competencia: Yup.string().required("**Campo requerido"),
    tipo_competencia: Yup.string().required("**Campo requerido"),
    area: Yup.string().required("**Campo requerido"),
    //division: Yup.string().required("**Campo requerido"),
    //nivel_desarrollo: Yup.string().required("***Campo requerido"),
    //clasificacion: Yup.string().required("**Campo requerido"),
  });

  const {
    loading,
    loadingById,
    saveLoading,
    saveLoadingById,
    assignCompetenciesLength,
    assignCompetencies,
    assignCompetencie,
    assignCompetenciesError,
    formError,
  } = useSelector((store) => store.assignCompetencies);

  const pages = assignCompetenciesLength / limit;

  const { loaderCompetenciesDesc, competenciesDesc, competenciesDescError } =
    useSelector((store) => store.competenciesDesc);

  const { competenciesTypes, competenciesTypeError } = useSelector(
    (store) => store.competenciesType
  );

  const loaderCompetenciesTypes = useSelector(
    (store) => store.competenciesType
  );

  const { loaderArea, areas, areasFaild } = useSelector(
    (store) => store.areasDescriptoresPerfiles
  );

  const { divisionLength, division } = useSelector((store) => store.division);
  const divisionLoading = useSelector((store) => store.division.loading);

  const { classification } = useSelector((store) => store.classification);
  const classificationLoading = useSelector(
    (store) => store.classification.loading
  );

  let competenciesList = [];
  if (competenciesDesc) {
    competenciesDesc.data.map((item) => {
      competenciesList = [
        ...competenciesList,
        {
          id: item.id,
          label: item.nombre,
        },
      ];
    });
  }

  let competenciesTypesList = [];
  if (competenciesTypes) {
    competenciesTypes.map((item) => {
      competenciesTypesList = [
        ...competenciesTypesList,
        {
          id: item.id,
          label: item.descripcion,
        },
      ];
    });
  }

  //Otros campos aparte de competencias

  let areasList = [];
  if (areas) {
    areas.data.map((item) => {
      areasList = [
        ...areasList,
        {
          id: item.id,
          label: item.descripcion,
        },
      ];
    });
  }

  let divisionList = [];
  if (division) {
    division.map((item) => {
      divisionList = [
        ...divisionList,
        {
          id: item.id,
          label: item.descripcion,
        },
      ];
    });
  }

  let classificationList = [];
  if (classification) {
    classification.map((item) => {
      classificationList = [
        ...classificationList,
        {
          id: item.id,
          label: item.nombre,
        },
      ];
    });
  }

  const columns = [
    {
      Header: "Competencia",
      accessor: "list_competencia[0].nombre",
    },
    {
      Header: "Tipo Competencia",
      accessor: "list_tipo_competencia[0].descripcion",
    },
    {
      Header: "Área",
      accessor: "list_area[0].descripcion",
    },
    {
      Header: "División",
      accessor: "list_division[0].descripcion",
    },
    {
      Header: "Clasificación",
      accessor: "list_Clasificacion[0].nombre",
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  const _getAssignCompetencies = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getAssignCompetencies({
        offset: offs,
        limit: lim,
        tipo_busqueda: "descriptor_id",
        filter: parseInt(props.match.params.id),
      })
    );

  useEffect(() => {
    _getAssignCompetencies();
    dispatch(getCompetenciesDesc({}));
    dispatch(getCompetenciesType({}));
    dispatch(getAreas({}));
    dispatch(getDivision({}));
    dispatch(getClassification({}));
    setValidated(false);
  }, [dispatch, props.match.params.id]);

  const onAdd = () => {
    setCompetencieSelected([]);
    setTipoCompetenciaSelected([]);
    setAreaSelected([]);
    setDivisionSelected([]);
    setClassificationSelected([]);
    setShowModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onEdit = (item, index) => {
    setCompetencieSelected([
      {
        id: item.competencia,
        label: item.list_competencia[0].nombre,
      },
    ]);
    setTipoCompetenciaSelected([
      {
        id: item.tipo_competencia,
        label: item.list_tipo_competencia[0].descripcion,
      },
    ]);
    setAreaSelected([
      {
        id: item.area,
        label: item.list_area[0].descripcion,
      },
    ]);

    setDivisionSelected([
      {
        id: item.division,
        label: item.list_division[0].descripcion,
      },
    ]);
    setClassificationSelected([
      {
        id: item.classification,
        label: item.list_Clasificacion[0].nombre,
      },
    ]);
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
  };

  const onSubmit = async (req) => {
    const _req = {
      ...req,
      descriptor: parseInt(props.match.params.id),
      nivel_desarrollo: 1,
    };

    if (!edit) {
      dispatch(saveAssignCompetenciesMF(_req, setShowModal));
    } else {
      dispatch(editAssignCompetencies(_req, editItem.id, index, setShowModal));
    }
    setShowModal(false);
    setCompetencieSelected([]);
    setTipoCompetenciaSelected([]);
    setAreaSelected([]);
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getAssignCompetencies(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteAssignCompetencies(id, index));
      window.alert("Se borro la competencia");
    }
  };


  return (
    <>
      <Container fluid>
        <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
          <h6 className="font-weight-bold text-uppercase">Competencias</h6>
          <Form onSubmit={onSearch}>
            <Row className="justify-content-end align-items-center flex-nowrap">
              <Col>
                <h6>
                  <b>Busqueda por: {/*ipoBusqueda.desc*/}</b>
                </h6>
              </Col>
              <Col xs="auto">
                <Form.Control
                  name="filter"
                  id="filter"
                  placeholder="Buscar"
                  className="rounded-pill form-control-sm"
                  type="search"
                ></Form.Control>
              </Col>
              <Col xs="auto">
                <ButtonGroup>
                  <Button
                    onClick={() => seeAll()}
                    variant="light"
                    size="sm"
                    className="rounded-circle"
                  >
                    <i className="material-icons">visibility</i>
                  </Button>

                  {/* <OverlayTrigger
                    placement="auto"
                    overlay={<Tooltip {...props}>Seleccionar Filtrado</Tooltip>}
                  >
                    <Dropdown className="ml-3 mr-3">
                        <Dropdown.Toggle
                          variant="primary"
                          className="btn-sm font"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              onClick={() => setTipoBusqueda(item)}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown> 
                  </OverlayTrigger> */}
                  <Button
                    variant="light"
                    size="sm"
                    className="rounded-circle"
                    onClick={() => onAdd()}
                  >
                    <i className="material-icons">add</i>
                  </Button>
                </ButtonGroup>
              </Col>
            </Row>
          </Form>
        </div>
        {loading ? (
          <div className="d-flex justify-content-center">
            <Spinner
              animation="border"
              role="status"
              className="d-flex justify-content-center"
            />
          </div>
        ) : (
          assignCompetenciesLength > 0 && (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable columns={columns} data={assignCompetencies} />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={assignCompetenciesLength}
                pages={pages}
                pagFunc={_getAssignCompetencies}
              />
            </>
          )
        )}
        {!loading &&
          assignCompetenciesLength === 0 &&
          assignCompetenciesError === "" && (
            <Alert variant="info" className="my-4">
              Aún no hay registros, comience agregando algunos
            </Alert>
          )}
        {!!assignCompetenciesError && (
          <Alert variant="danger" className="mt-4 mb-1 mx-3">
            {assignCompetenciesError}
          </Alert>
        )}
      </Container>
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
          setCompetencieSelected([]);
          setTipoCompetenciaSelected([]);
        }}
      >
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            competencia: edit
              ? editItem.competencia === null
                ? ""
                : editItem.competencia
              : "",
            tipo_competencia: edit
              ? editItem.tipo_competencia === null
                ? ""
                : editItem.tipo_competecia
              : "",
            area: edit ? (editItem.area === null ? "" : editItem.area) : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  {edit ? "Editar competencia" : "Asignar competencias"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formError && (
                  <Alert variant="danger" className="mt-4 mb-1 mx-3">
                    {formError}
                  </Alert>
                )}
                <Form.Group as={Col} className="mb-1">
                  <Form.Label column sm="12" md="12">
                    Competencias:
                  </Form.Label>
                  <Typeahead
                    id="competencia"
                    name="competencia"
                    isInvalid={touched.competencia && errors.competencia}
                    isValid={touched.competencia && !errors.competencia}
                    onBlur={handleBlur("competencia")}
                    placeholder="Seleccione una opción"
                    options={competenciesList}
                    onChange={(selected) => {
                      setFieldValue(
                        "competencia",
                        selected.length > 0 ? selected[0].id : ""
                      );
                      setCompetencieSelected(selected);
                    }}
                    selected={competencieSelected}
                    disabled={competenciesList.length === 0}
                  ></Typeahead>
                  {loaderCompetenciesDesc && (
                    <Col sm={1}>
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                  {touched.competencia && errors.competencia && (
                    <Col>
                      <small className="text-danger">
                        {errors.competencia}
                      </small>
                    </Col>
                  )}
                  {!!competenciesDescError && (
                    <Col>
                      <small className="text-danger">
                        **{competenciesDescError}
                      </small>
                    </Col>
                  )}
                  {!loaderCompetenciesDesc && competenciesList.length === 0 && (
                    <Col>
                      <small className="text-danger">
                        **No se encontraron competencias
                      </small>
                    </Col>
                  )}
                  {/**{formErrorJson &&
                  typeof formErrorJson === "object" &&
                  formErrorJson.nivel_academico ? (
                    <Col>
                      {formErrorJson.nivel_academico.map((item) => (
                        <small className="text-danger">**{item}</small>
                      ))}
                    </Col>
                  ) : null} */}
                </Form.Group>
                <Form.Group as={Col} className="mb-1">
                  <Form.Label column sm="12" md="12">
                    Tipo de competencia:
                  </Form.Label>
                  <Typeahead
                    id="tipo_competencia"
                    name="tipo_competecia"
                    isInvalid={
                      touched.tipo_competencia && errors.tipo_competencia
                    }
                    isValid={
                      touched.tipo_competencia && !errors.tipo_competencia
                    }
                    onBlur={handleBlur("tipo_competencia")}
                    placeholder="Seleccione una opción"
                    options={competenciesTypesList}
                    onChange={(selected) => {
                      setFieldValue(
                        "tipo_competencia",
                        selected.length > 0 ? selected[0].id : ""
                      );
                      setTipoCompetenciaSelected(selected);
                    }}
                    selected={tipoCompetenciaSelected}
                    disabled={competenciesTypesList.length === 0}
                  ></Typeahead>
                  {/**{loaderCompetenciesTypes && loaderCompetenciesTypes &&(
                    <Col sm={1}>
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )} */}
                  {touched.tipo_competencia && errors.tipo_competencia && (
                    <Col>
                      <small className="text-danger">
                        {errors.tipo_competencia}
                      </small>
                    </Col>
                  )}
                  {!!competenciesTypeError && (
                    <Col>
                      <small className="text-danger">
                        **{competenciesTypeError}
                      </small>
                    </Col>
                  )}
                  {!loaderCompetenciesTypes &&
                    competenciesTypesList.length === 0 && (
                      <Col>
                        <small className="text-danger">
                          **No se encontraron tipos de competencias
                        </small>
                      </Col>
                    )}
                  {/*{formErrorJson &&
                  typeof formErrorJson === "object" &&
                  formErrorJson.area_conocimiento ? (
                    <Col>
                      {formErrorJson.area_conocimiento.map((item) => (
                        <small className="text-danger">**{item}</small>
                      ))}
                    </Col>
                  ) : null} */}
                </Form.Group>
                <Form.Group as={Col} className="mb-1">
                  <Form.Label column sm="12" md="12">
                    Área:
                  </Form.Label>
                  <Typeahead
                    id="area"
                    name="area"
                    isInvalid={touched.area && errors.area}
                    isValid={touched.area && !errors.area}
                    onBlur={handleBlur("area")}
                    placeholder="Seleccione una opción"
                    options={areasList}
                    onChange={(selected) => {
                      setFieldValue(
                        "area",
                        selected.length > 0 ? selected[0].id : ""
                      );
                      setAreaSelected(selected);
                    }}
                    selected={areaSelected}
                    disabled={areasList.length === 0}
                  ></Typeahead>
                  {loaderArea && (
                    <Col sm={1}>
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                  {touched.area && errors.area && (
                    <Col>
                      <small className="text-danger">{errors.area}</small>
                    </Col>
                  )}
                  {!!areasFaild && (
                    <Col>
                      <small className="text-danger">**{areasFaild}</small>
                    </Col>
                  )}
                  {!loaderArea && areasList.length === 0 && (
                    <Col>
                      <small className="text-danger">
                        **No se encontraron areas
                      </small>
                    </Col>
                  )}
                  {/*{formErrorJson &&
                  typeof formErrorJson === "object" &&
                  formErrorJson.area_conocimiento ? (
                    <Col>
                      {formErrorJson.area_conocimiento.map((item) => (
                        <small className="text-danger">**{item}</small>
                      ))}
                    </Col>
                  ) : null} */}
                </Form.Group>
                <Form.Group as={Col} className="mb-1">
                  <Form.Label column sm="12" md="12">
                    División:
                  </Form.Label>
                  <Typeahead
                    id="division"
                    name="division"
                    isInvalid={touched.division && errors.division}
                    isValid={touched.division && !errors.division}
                    onBlur={handleBlur("division")}
                    placeholder="Seleccione una opción"
                    options={divisionList}
                    onChange={(selected) => {
                      setFieldValue(
                        "division",
                        selected.length > 0 ? selected[0].id : ""
                      );
                      setDivisionSelected(selected);
                    }}
                    selected={divisionSelected}
                    disabled={divisionList.length === 0}
                  ></Typeahead>
                  {/**{loaderCompetenciesTypes && loaderCompetenciesTypes &&(
                    <Col sm={1}>
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )} */}
                  {touched.division && errors.division && (
                    <Col>
                      <small className="text-danger">{errors.division}</small>
                    </Col>
                  )}
                  {/*!!competenciesTypeError && (
                    <Col>
                      <small className="text-danger">
                        **{competenciesTypeError}
                      </small>
                    </Col>
                  )*/}
                  {!divisionLoading && divisionList.length === 0 && (
                    <Col>
                      <small className="text-danger">
                        **No se encontraron divisiones
                      </small>
                    </Col>
                  )}
                  {/*{formErrorJson &&
                  typeof formErrorJson === "object" &&
                  formErrorJson.area_conocimiento ? (
                    <Col>
                      {formErrorJson.area_conocimiento.map((item) => (
                        <small className="text-danger">**{item}</small>
                      ))}
                    </Col>
                  ) : null} */}
                </Form.Group>
                <Form.Group as={Col} className="mb-1">
                  <Form.Label column sm="12" md="12">
                    Clasificación:
                  </Form.Label>
                  <Typeahead
                    id="clasificacion"
                    name="clasificacion"
                    isInvalid={touched.clasificacion && errors.clasificacion}
                    isValid={touched.clasificacion && !errors.clasificacion}
                    onBlur={handleBlur("clasificacion")}
                    placeholder="Seleccione una opción"
                    options={classificationList}
                    onChange={(selected) => {
                      setFieldValue(
                        "clasificacion",
                        selected.length > 0 ? selected[0].id : ""
                      );
                      setClassificationSelected(selected);
                    }}
                    selected={classificationSelected}
                    disabled={classificationList.length === 0}
                  ></Typeahead>
                  {/**{loaderCompetenciesTypes && loaderCompetenciesTypes &&(
                    <Col sm={1}>
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )} */}
                  {touched.clasificacion && errors.clasificacion && (
                    <Col>
                      <small className="text-danger">
                        {errors.clasificacion}
                      </small>
                    </Col>
                  )}
                  {/*!!competenciesTypeError && (
                    <Col>
                      <small className="text-danger">
                        **{competenciesTypeError}
                      </small>
                    </Col>
                  )*/}
                  {!classificationLoading && classificationList.length === 0 && (
                    <Col>
                      <small className="text-danger">
                        **No se encontraron clasificaciones
                      </small>
                    </Col>
                  )}
                  {/*{formErrorJson &&
                  typeof formErrorJson === "object" &&
                  formErrorJson.area_conocimiento ? (
                    <Col>
                      {formErrorJson.area_conocimiento.map((item) => (
                        <small className="text-danger">**{item}</small>
                      ))}
                    </Col>
                  ) : null} */}
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                <Button
                  className="rounded-pill"
                  disabled={saveLoading}
                  variant="primary"
                  type="submit"
                >
                  {saveLoading && (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default AssignCompetencies;
